import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-px gap-2 relative min-h-300 flex flex-col justify-center items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Loading SMS Trust ", -1)
const _hoisted_3 = {
  key: 1,
  class: "flex justify-center flex-col gap-2 max-w-screen-sm mx-auto h-full"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-medium" }, " Activate US text messaging ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-light text-gray-500" }, " Carriers require that all VolP numbers be registered before they can send text messages to US numbers. ", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex gap-4 items-center justify-between p-2 border rounded-md mb-3 transition border-red-400"
}
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-medium" }, " US text messaging verification failed ", -1)
const _hoisted_9 = { class: "text-sm font-light text-red-600" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex flex-col gap-2 mb-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-medium" }, " US text messaging verification ", -1)
const _hoisted_13 = { class: "flex p-2 justify-between border rounded-md border-gray-400 text-sm" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, " Brand registration ", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_16 = { class: "flex p-2 justify-between border rounded-md border-gray-400 text-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, " Campain registration ", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-xs"
}

import {
	UiCard,
	UiLine,
	UiButton,
	UiLoader
} from '@/ui-kit';
import { useSmsTrustState } from '../state';
import { computed, onBeforeMount, ref } from 'vue';
import TrustForm from '../components/TrustForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Trust',
  setup(__props) {

const smsTrust = useSmsTrustState();

onBeforeMount(() => {
	if (!smsTrust.isLoading) {
		return;
	}

	smsTrust.loadTrust();
});

const errors = computed(() =>
	smsTrust.trustState?.data?.evaluation_results.flatMap(
		(item) => {
			return item.fields
				.filter((item: any) => !item.passed)
				.map(
					(item: any) =>
						`${item.friendly_name} ${item.failure_reason}`
				);
		}
	)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiCard), {
    theme: "white",
    class: "relative pt-4 px-4 flex-grow",
    title: "SMS Trust"
  }, {
    default: _withCtx(() => [
      (_unref(smsTrust).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(UiLoader))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_unref(smsTrust).trustState)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(smsTrust).isTrustFormOpened)
                    ? (_openBlock(), _createBlock(TrustForm, { key: 0 }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _hoisted_4,
                        _hoisted_5,
                        _createElementVNode("div", null, [
                          _createVNode(_unref(UiButton), {
                            onClick: 
								_unref(smsTrust).openSmsTrustForm
							
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Get Started ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(smsTrust).trustState)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (
							_unref(smsTrust).trustState &&
							_unref(smsTrust).isNonComplient
						)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("ul", _hoisted_9, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (err, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: "list-disc ml-5",
                                      key: i
                                    }, _toDisplayString(err), 1))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["capitalize flex flex-col gap-0.5", {
										'text-green-500':
											_unref(smsTrust)
												.trustState
												.brand
												?.status ===
												'registered' ||
											_unref(smsTrust).trustState.campaign?.brand?.toLowerCase() ===
												'approved',
										'text-red-400':
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'FAILED' ||
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'SUSPENDED'
									}])
                                  }, [
                                    _createTextVNode(_toDisplayString(_unref(smsTrust).trustState.brand.status
											.split('_')
											.join(' ')) + " ", 1),
                                    (
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'FAILED' ||
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'SUSPENDED'
										)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(smsTrust)
												.trustState
												.brand
												.brand_feedback ||
											_unref(smsTrust)
												.trustState
												.brand
												.failure_reason), 1))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["capitalize", {
										'text-green-500':
											_unref(smsTrust)
												.trustState
												.campaign
												?.status ===
												'registered' ||
											_unref(smsTrust).trustState.campaign?.status?.toLowerCase() ===
												'approved',
										'text-red-400':
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'FAILED' ||
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'SUSPENDED'
									}])
                                  }, [
                                    _createTextVNode(_toDisplayString((
											_unref(smsTrust)
												.trustState
												.campaign
												?.status ||
											'Pending'
										)
											.split('_')
											.join(' ')) + " ", 1),
                                    (
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'FAILED' ||
											_unref(smsTrust)
												.trustState
												.brand
												.status ===
												'SUSPENDED'
										)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(smsTrust)
												.trustState
												.campaign
												.brand_feedback ||
											_unref(smsTrust)
												.trustState
												.campaign
												.failure_reason), 1))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ])
                              ])
                            ]))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(TrustForm, {
                    state: _unref(smsTrust).trustState
                  }, null, 8, ["state"])
                ], 64))
          ], 64))
    ]),
    _: 1
  }))
}
}

})